module.exports = __webpack_public_path__ + "img/derivatives.a9d444a2.png";